
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Sparkles, Zap, Brain, Star, Lock, CheckCircle2 } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { useUserStore } from "@/store/userStore";

export const PremiumFeatures = () => {
  const { toast } = useToast();
  const { isPremium, setPremium } = useUserStore();
  
  const handleUpgrade = () => {
    if (!isPremium) {
      setPremium(true);
      toast({
        title: "Welcome to Premium!",
        description: "You now have access to all premium AI job matching features",
        variant: "success",
      });
    }
  };
  
  const premiumFeatures = [
    {
      icon: Brain,
      title: "Advanced AI Analysis",
      description: "Get deeper insights into job requirements and company culture",
    },
    {
      icon: Star,
      title: "Accurate Match Scores",
      description: "See precisely how well your skills match each job",
    },
    {
      icon: Zap,
      title: "Priority Applications",
      description: "Your applications get seen by employers first",
    },
    {
      icon: CheckCircle2,
      title: "Resume Optimization",
      description: "AI-powered suggestions to improve your resume",
    },
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Sparkles className="text-amber-500" />
          {isPremium ? "Premium Features (Active)" : "Upgrade to Premium"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {premiumFeatures.map((feature, index) => (
            <div key={index} className="flex gap-3">
              <div className={`mt-0.5 ${isPremium ? "text-emerald-500" : "text-gray-400"}`}>
                {isPremium ? (
                  <feature.icon className="w-5 h-5" />
                ) : (
                  <Lock className="w-5 h-5" />
                )}
              </div>
              <div>
                <h3 className="text-sm font-medium">{feature.title}</h3>
                <p className="text-xs text-gray-500 mt-1">{feature.description}</p>
              </div>
            </div>
          ))}
          
          {!isPremium && (
            <Button 
              onClick={handleUpgrade}
              className="w-full mt-4 bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600"
            >
              <Sparkles className="mr-2 h-4 w-4" />
              Unlock Premium
            </Button>
          )}
          
          {isPremium && (
            <div className="mt-4 p-3 bg-emerald-50 rounded-md">
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="bg-gradient-to-r from-amber-200 to-amber-400 text-amber-900 border-amber-500">
                  <Star className="w-3 h-3 mr-1 fill-amber-500 text-amber-500" /> Premium
                </Badge>
                <span className="text-xs font-medium text-emerald-700">Active</span>
              </div>
              <p className="text-xs text-gray-600 mt-2">
                You have access to all premium features. Enjoy enhanced AI job matching!
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
